export default __webpack_public_path__ + "static/media/argentan9.8ace36e1.jpg";